import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '90%',
    borderWidth: 1,
    borderRadius: 8,
    marginTop: 26,
    borderColor: '#dbdbdb'
  },
  titleContainer: {
    position: 'absolute',
    backgroundColor: '#ffffff',
    width: '100%',
    flexDirection: 'row',
    left: 0,
    top: -18
  },
  mainTitle: {
    fontSize: 10,
    marginRight: 3,
    backgroundColor: '000'
  },
  emoji: {
    marginRight: 3,
    fontSize: 11
  },
  singleParagraph: {
    width: '100%',
    marginVertical: 10,
    paddingLeft: 10,
    borderStyle: 'solid',
    borderColor: '#dbdbdb',
    alignItems: 'flex-start',
    flexDirection: 'row'
  },
  singleParagraphShort: {
    width: '100%',
    marginVertical: -6,
    paddingLeft: 10,
    paddingRight: 10,
    borderStyle: 'solid',
    borderColor: '#dbdbdb',
    alignItems: 'flex-start',
    flexDirection: 'row'
  },
  title: {
    fontSize: 7,
    color: '#000'
  },
  description: {
    fontSize: 7,
    color: '#252525'
  },
  subtitle: {
    fontSize: 10,
    color: 'black'
  },
  content: { padding: 8 }
})

export default styles
